/**
 * 微信授权相关工具函数
 */

// 获取微信授权URL
export const getWechatAuthUrl = (redirectUri?: string): string => {
  const appId = import.meta.env.VITE_WX_APP_ID;
  const finalRedirectUri = redirectUri || encodeURIComponent(window.location.href);

  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${finalRedirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
};

// 获取新的微信授权code（跳转到微信授权页面）
export const getNewWechatCode = (customRedirectUrl?: string) => {
  // 保存当前页面状态到localStorage（保留表单数据和路径信息）
  const currentPath = window.location.pathname;

  // 保存授权前的状态，用于授权后恢复
  localStorage.setItem(
    'beforeAuth',
    JSON.stringify({
      path: currentPath,
    }),
  );
  // 构建授权后的回调URL - 确保回到当前页面而不是登录选择页面
  const currentUrl = customRedirectUrl || (window.location.origin + currentPath);
  const redirectUri = encodeURIComponent(currentUrl);

  // 跳转到微信授权页面
  const authUrl = getWechatAuthUrl(redirectUri);
  window.location.href = authUrl;
};
// 恢复授权前的页面状态（如表单数据）
export const restoreBeforeAuthState = () => {
  try {
    const savedState = localStorage.getItem('beforeAuth');
    if (savedState) {
      const state = JSON.parse(savedState);
      // 清除保存的状态，避免重复使用
      localStorage.removeItem('beforeAuth');
      return state;
    }
  } catch (error) {
    console.error('恢复授权前状态失败:', error);
  }
  return null;
};

// 恢复表单数据
export const restoreFormData = () => {
  try {
    const savedFormData = localStorage.getItem('beforeAuthFormData');
    if (savedFormData) {
      const formData = JSON.parse(savedFormData);
      // 清除保存的表单数据
      localStorage.removeItem('beforeAuthFormData');
      return formData;
    }
  } catch (error) {
    console.error('恢复表单数据失败:', error);
  }
  return null;
};

// 检查当前是否是从微信授权返回
export const isFromWechatAuth = () => {
  const code = getQuery('code');
  const savedState = localStorage.getItem('beforeAuth');
  return !!(code && savedState);
};

/**
 * 从URL中获取查询参数
 * @param paramName 参数名称
 * @param url 目标URL，默认为当前页面URL
 * @returns 参数值或null
 */
export function getQuery(paramName: string, url: string = location.href): string | null {
  try {
    const urlObj = new URL(url);
    return urlObj.searchParams.get(paramName);
  } catch (error) {
    console.error('解析URL失败:', error);
    return null;
  }
}
